import { render, staticRenderFns } from "./PrincipalColor.vue?vue&type=template&id=22dfca32&scoped=true"
import script from "./PrincipalColor.vue?vue&type=script&lang=js"
export * from "./PrincipalColor.vue?vue&type=script&lang=js"
import style0 from "./PrincipalColor.vue?vue&type=style&index=0&id=22dfca32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dfca32",
  null
  
)

export default component.exports